import { css } from 'styled-components';
import indents from '../../constants/js/indents.js';
import fieldSizes from '../../constants/js/field-sizes.js';
import textSizes from '../../constants/js/text.js';

const leftRightPaddings = paddingWOIcon => ({
  leftIcon,
  rightIcon,
  isNoChildren
}) => (leftIcon || rightIcon) && !isNoChildren ? '' : paddingWOIcon;

export const buttonSizes = {
  h32: css(["height:", ";min-width:", ";line-height:", ";padding:", " ", ";font-size:", ";"], fieldSizes.h32, fieldSizes.h32, textSizes.lineHeight7, indents.indentXS, leftRightPaddings(indents.indent12), textSizes.fontSize7),
  h40: css(["height:", ";min-width:", ";line-height:", ";padding:", " ", ";font-size:", ";"], fieldSizes.h40, fieldSizes.h40, textSizes.lineHeight5, indents.indentXS, leftRightPaddings(indents.indentS), textSizes.fontSize5),
  h48: css(["height:", ";min-width:", ";line-height:", ";padding:", " ", ";font-size:", ";"], fieldSizes.h48, fieldSizes.h48, textSizes.lineHeight5, indents.indent12, leftRightPaddings(indents.indentS), textSizes.fontSize5),
  h56: css(["height:", ";min-width:", ";line-height:", ";padding:", " ", ";font-size:", ";"], fieldSizes.h56, fieldSizes.h56, textSizes.lineHeight5, indents.indentS, leftRightPaddings(indents.indentM), textSizes.fontSize5)
};
export const iconSizes = {
  h32: 'size16',
  h40: 'size24',
  h48: 'size24',
  h56: 'size24'
};
export const loaderSizes = {
  h32: 'xsmall',
  h40: 'small',
  h48: 'small',
  h56: 'small'
};